// @flow
import { connect } from 'react-redux';

import { searchParametersState } from '../../../Serp/selectors';
import FilterTagsList from '.';
import { getVerticalName } from '~/common/selectors/config';

type MapStateToProps = {
  searchParams: Object,
  verticalName: string,
};

function mapStateToProps(state): MapStateToProps {
  return {
    searchParams: searchParametersState(state),
    verticalName: getVerticalName(state),
  };
}
const FilterTagsListContainer = connect(mapStateToProps)(FilterTagsList);

FilterTagsListContainer.displayName = 'FilterTagListContainer';

export default FilterTagsListContainer;



// WEBPACK FOOTER //
// ./app/common/FilterTags/list/container.js